import _ from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { Button } from 'react-bootstrap';
import { StyledSelect } from '.';
import { useUserContext } from '../contexts/UserContext';
import { ADMIN_SHARED_OPTIONS, COMMON_SHARED_OPTIONS, sharedByMe, sharedByTeam, sharedWithTeam, SHARED_OPTIONS_URL_PARAMS } from '../helpers/configureHelper';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectSelectedMembersBy,
  selectSelectedMembersTo,
  selectSharedTo,
  setSelectableTotalMembers,
  setSelectedMembersBy,
  setSelectedMembersTo,
  setSharedTo,
  selectableMembersCount,
  selectSharedPanelOpenBy,
  setSharedPanelOpenBy,
} from '../redux/slicers/filters/filterSlicer';
import { isAdminOrOwner } from '../helpers/userHelper';
import UserIcon from '../components/icons/UserIcon';
import { TeamMembersFilterOverlayUI } from '../components/TeamMembersFilter/TeamMembersFilter';
import { MODE, useApiList } from '../hooks/useApiList';
import { apiGetMembersListV2, apiGetSharingOutsideMembersListV2, apiGetTeamMembers, apiGetTeamMembersNew, apiGetTeamMembersV4 } from '../helpers/api';
import { With_Me_Value } from '../constants/filters';
import { selectTeamMembersFilterOpen, setRightOffcanvasOpen, setSharedMemberCanvasOpen } from '../redux/slicers/uiSlicer';
import { useSearchParams } from "react-router-dom";
import { removeDuplicateEntry } from "../helpers/jsHelper";

export const TeamMembersSharedFilesFilter = (props) => {
  const dispatch = useDispatch();
  const { currentUser } = useUserContext();
  const [searchParams, setSearchParams] = useSearchParams();
  const totalMembers = useSelector(selectableMembersCount)
  const selectedMembersBy = useSelector(selectSelectedMembersBy);
  const selectedMembersTo = useSelector(selectSelectedMembersTo);
  const sharedTo = useSelector(selectSharedTo);
  const sharedPanelOpenBy = useSelector(selectSharedPanelOpenBy);
  const show = useSelector(selectTeamMembersFilterOpen);

  const [isMemberFilterVisible, toggleMemberFilter] = useState(false);

  useEffect(() => {
    props?.setSharedMembersFilterShow?.(isMemberFilterVisible)
    dispatch(setSharedMemberCanvasOpen(isMemberFilterVisible))
  }, [isMemberFilterVisible])

  const SHARED_OPTIONS = isAdminOrOwner(currentUser) ? [...COMMON_SHARED_OPTIONS, ...ADMIN_SHARED_OPTIONS] : COMMON_SHARED_OPTIONS

  const selectedOption = SHARED_OPTIONS.find((o) => o.value === sharedTo);

  const handleShareDropdownChange = (option) => {
    window.$restrictFilter = null
    dispatch(setSharedTo(option.value));
    searchParams.set('sharedOption',option.value)
    setSearchParams(searchParams);
    if(option.value === sharedWithTeam.value || option.value === sharedByTeam.value){
      toggleMemberFilter(true);
      dispatch(setSharedPanelOpenBy('admin'));
    }
  };

  const checkIfClosingEmpty = () => {
    if((sharedTo === sharedWithTeam.value || sharedTo === sharedByTeam.value) && !selectedMembersTo?.length){
      dispatch(setSharedTo(With_Me_Value));
    }
  }

  return (
    <div className="d-flex align-items-center gap-3">
      {
        <>
          {!props?.hideOptionList && (
            <>
              <span>Shared</span>
              <div className="minWidth135">
                <StyledSelect
                  value={selectedOption}
                  onChange={handleShareDropdownChange}
                  options={SHARED_OPTIONS}
                  placeholder="Select"
                />
              </div>
              <span>
                {sharedTo === sharedByMe.value || sharedTo === sharedByTeam.value ? 'With' : 'By'}
              </span>

              <SharedByButton
                members={selectedMembersBy}
                onClick={() => {
                  toggleMemberFilter(!isMemberFilterVisible);
                  dispatch(setSharedPanelOpenBy('user'));
                }}
              />
            </>
          )}
          <TeamMembersFilterOverlayUIController
            {...props}
            show={isMemberFilterVisible || show}
            onClose={() => {
              toggleMemberFilter(false);
              dispatch(setSharedPanelOpenBy(''));
              // checkIfClosingEmpty();
              dispatch(setRightOffcanvasOpen(false));
              dispatch(setSharedMemberCanvasOpen(false));
            }}
            onChange={
              isAdminOrOwner(currentUser)
                ? (sharedTo === sharedWithTeam.value || sharedTo === sharedByTeam.value) &&
                  sharedPanelOpenBy === 'admin'
                  ? (m) => dispatch(setSelectedMembersBy(m))
                  : (m) => dispatch(setSelectedMembersBy(m))
                : (m) => dispatch(setSelectedMembersBy(m))
            }
            selectedMembers={
              isAdminOrOwner(currentUser)
                ? (sharedTo === sharedWithTeam.value || sharedTo === sharedByTeam.value) &&
                  sharedPanelOpenBy === 'admin'
                  ? selectedMembersBy
                  : selectedMembersBy
                : selectedMembersBy
            }
          />
        </>
      }
    </div>
  );
};

export const SharedByButton = ({ members, onClick }) => {
  const totalMembers = useSelector(selectableMembersCount);
  return (
    <>
      {
        (members.length > 0 && members.length < totalMembers)
        ? (
          <>
            <div className="custom-imges user-icon-top ">
              <span style={{ cursor: 'pointer', display: 'flex' }} onClick={onClick}>
                {members.map((item, index) =>
                  index < 2 ? (
                    <span className="avatar" key={index}>
                      {item?.avatar ? <img src={item.avatar} /> : <UserIcon />}
                    </span>
                  ) : null
                )}
                {members.length > 2 && (
                  <span className="avatar avtar-count-part ">+{members.length - 2}</span>
                )}
              </span>
            </div>
          </>
        ) : (
          <Button className="allUsers" variant={''} onClick={onClick}>
            All
          </Button>
        )}
    </>
  );
};


const TeamMembersFilterOverlayUIController = (props) => {
  const { currentUser } = useUserContext();
  const dispatch = useDispatch();
  const [search, setSearch] = useState('');
  const [sections, setSections] = useState([]);
  const sharedPanelOpenBy = useSelector(selectSharedPanelOpenBy);

  const requestParams = useMemo(() => {
    return {
      isMyOrg: true,
      perPage: 50,
      search: search,
    };
  }, [search]);

  const insideList = useApiList({
    api: apiGetTeamMembersV4, //apiGetMembersListV2,
    mode: MODE.PARAMS,
    defaultPerPage: 20,
    params: {
      ...requestParams
    },
    fetchAll: true,
  })

  const outsideList = useApiList({
    api: apiGetSharingOutsideMembersListV2, // apiGetMembersListV2,
    mode: MODE.PARAMS,
    defaultPerPage: 20,
    params: {
      isMyOrg: false,
    }
  })

  const outsideMembersList = 
      {
        noItemsText: 'No user found!',
        fetchMoreData: outsideList.fetchNextPage,
        loading: outsideList.loading,
        title: 'Other organization members',
        name: 'OUTSIDE_MEMBERS',
        hasMore: outsideList.hasMore,
        items: outsideList.list.map((member) => {
          const name = member.member_name || member.member_email

          return {
            id: member.id,
            name: name,
            avatar: member.member_profile,
            organization: member?.organization_details?.name,
          };
        }),
      }

  let localSections = [
    {
      noItemsText: 'No user found!',
      fetchMoreData: insideList.fetchNextPage,
      loading: insideList.loading,
      name: 'INSIDE_MEMBERS',
      hasMore: insideList.hasMore,
      items: insideList.list.map((member) => {
        const name = (member?.user?.name || member?.user?.email) || (member.member_name || member.member_email)

        return {
          id: member.id,
          name: name,
          avatar: member?.user?.profile_image || member.member_profile,
        };
      }),
    },
  ];

  // let listM = [];
  useEffect(() => {

    if(!sharedPanelOpenBy) return;

    if(sharedPanelOpenBy === 'user') {
      localSections.push(outsideMembersList)
    } else {
      localSections = localSections.filter(a => a.name !== 'OUTSIDE_MEMBERS')
      localSections.push(outsideMembersList)
    }

    const listM = sharedPanelOpenBy === 'admin' ? insideList.list?.length : insideList.list?.length + outsideList.list?.length
    const removeDuplicateRecord = []
    localSections?.map((list) => {
      removeDuplicateRecord.push(
        {
          ...list,
          items:removeDuplicateEntry(list?.items)
        }
      )
    })
    setSections(removeDuplicateRecord);
    dispatch(setSelectableTotalMembers(listM));

  }, [currentUser, insideList.list, outsideList.list, sharedPanelOpenBy])

  return (
    <TeamMembersFilterOverlayUI
      {...props}
      sections={sections}
      search={search}
      onSearchChange={(e) => setSearch(e.target.value)}
    />
  )
}